export var getItemLabel = function getItemLabel(translate, key, label) {
  if (label) return label;
  return translate(key);
};
export var getPlacement = function getPlacement(placement) {
  switch (placement) {
    case 'None':
      return undefined;
    case 'Top Left':
      return 'top-end';
    case 'Top Right':
      return 'top-start';
    case 'Top Center':
      return 'top';
    case 'Bottom Left':
      return 'bottom-end';
    case 'Bottom Right':
      return 'bottom-start';
    case 'Bottom Center':
      return 'bottom';
    case 'Left':
      return 'left';
    case 'Right':
      return 'right';
  }
};